/* @flow */

import { plainToClass } from 'class-transformer';

import BaseService from './api/baseService';

import DebtorCompany from 'models/companies/debtorCompany';
import Invoice from 'models/invoices/seller/invoice';
import InvoiceBatch from 'models/invoices/seller/invoiceBatch';
import InvoiceBills from 'models/invoices/seller/invoiceBills';
import InvoiceCompensation from 'models/invoices/seller/invoiceCompensation';
import InvoiceDetails from 'models/invoices/seller/invoiceDetails';
import InvoiceFixPrices from 'models/invoices/seller/invoiceFixPrices';
import InvoiceFlexPrices from 'models/invoices/seller/invoiceFlexPrices';
import Kpi from 'models/dashboards/kpi';

import {
  SUPPLIER_INVOICES_DETAILS_GET,
  SUPPLIER_INVOICES_GET
} from 'constants/apiRoutes';

export default class ConfirmingService {

  // Load details of an invoice
  static getInvoiceDetails = (companyId: number, invoiceId: number) =>
    BaseService.simpleGET(`${SUPPLIER_INVOICES_DETAILS_GET}/${companyId}/${invoiceId}`,
      data => {
        if (!data.invoice) return null;

        const invoice = plainToClass(InvoiceDetails, data.invoice);
        const batch = this.mapInvoiceBatch(data.batch);
        invoice.debtorCompany = plainToClass(DebtorCompany, data.invoice.debtorCompany);
        if (data.invoice.flexPrices) {
          invoice.flexPrices = plainToClass(InvoiceFlexPrices, data.invoice.flexPrices);
          if (data.invoice.flexPrices.compensations) {
            invoice.flexPrices.compensations = data.invoice.flexPrices.compensations.map(c => plainToClass(InvoiceCompensation, c));
          }
        }
        if (data.invoice.fixFinancedPrices) invoice.fixFinancedPrices = plainToClass(InvoiceFixPrices, data.invoice.fixFinancedPrices);
        if (data.invoice.fixUnfinancedPrices) invoice.fixUnfinancedPrices = plainToClass(InvoiceFixPrices, data.invoice.fixUnfinancedPrices);

        const bills = plainToClass(InvoiceBills, data.bills);

        let kpis = null;
        if (data.kpis) {
          kpis = data.kpis.map(d => plainToClass(Kpi, d));
        }

        return { bills, invoice, batch, kpis };
      });

  // Load invoices
  static getInvoices = (companyId: number) =>
    BaseService.simpleGET(`${SUPPLIER_INVOICES_GET}/${companyId}`,
      data => data.map(d => plainToClass(Invoice, d)));

  static mapInvoiceBatch = (batch) => {
    const batchArray = [];
    batch.forEach((invoiceBatch) => {
      const mappedInvoiceBatch = plainToClass(InvoiceBatch, invoiceBatch);
      batchArray.push(mappedInvoiceBatch);
    })
    return batchArray;
  }
}
